import { render } from "./LocaleSelectorItem.vue?vue&type=template&id=b161f362&scoped=true"
import script from "./LocaleSelectorItem.vue?vue&type=script&lang=js"
export * from "./LocaleSelectorItem.vue?vue&type=script&lang=js"

import "./LocaleSelectorItem.vue?vue&type=style&index=0&id=b161f362&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b161f362"]])

export default __exports__